export function asComponent(component, args={}) {
    component = new component(args);
    return component.code();
}
